import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
import type { VillaHostCity } from "../villa-host.types";
import { CityCard } from "./city-card";
import styles from "./villa-host-city-carousel.module.scss";
const CITY_CARD_STEP_IN_PIXELS = 256;
const SPEED_IN_PIXELS_PER_SECOND = 15;
export const VillaHostCityCarousel = t0 => {
  const $ = _c(17);
  const {
    cities
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== cities) {
    const cityGroups = [cities, cities];
    const marqueeDuration = cities.length * CITY_CARD_STEP_IN_PIXELS / SPEED_IN_PIXELS_PER_SECOND;
    t4 = "relative w-screen overflow-hidden text-right";
    t5 = "rtl";
    t1 = `${styles.track} inline-flex w-max gap-4`;
    const t6 = `${marqueeDuration}s`;
    let t7;
    if ($[6] !== cities.length || $[7] !== t6) {
      t7 = {
        "--city-count": cities.length,
        "--marquee-duration": t6
      };
      $[6] = cities.length;
      $[7] = t6;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    t2 = t7 as CSSProperties;
    t3 = cityGroups.map(_temp);
    $[0] = cities;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t6 = <div className={t1} style={t2}>{t3}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className={t4} dir={t5}>{t6}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
function _temp(group, groupIndex) {
  return <div aria-hidden={groupIndex === 1} className="flex shrink-0 gap-4" key={groupIndex}>{group.map(city => <div className="shrink-0" key={`${city.en}-${groupIndex}`}><CityCard city={city} /></div>)}</div>;
}